interface NestedObject {
  [key: string]: any;
  defaultValue?: any;
}

export const flattenNestedObject = (obj: NestedObject): NestedObject => {
  const simplified = {};

  for (const key in obj) {
    if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      simplified[key] = flattenNestedObject(obj[key]);
    } else {
      return obj.defaultValue;
    }
  }

  return simplified;
};
